// npm
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// css
import '../../scss/pages/page-technology.scss';

// utils
import foundation from '../_utils/foundation';
import Ease from '../_utils/Ease';
foundation();

document.addEventListener('DOMContentLoaded', () => {
	const $fv = document.querySelector('.js-fv');
	if ($fv) {
		const $headline = $fv.querySelector('.js-fv-headline');
		const $headlineEn = $headline.querySelector('.js-fv-headline-en');
		const $headlineJa = $headline.querySelector('.js-fv-headline-ja');
		const $enChar = $headlineEn.querySelectorAll('.char');
		const $fvfade = $headline.querySelectorAll('.js-fv-fade');

		function fvAnimation() {
			gsap.set($headline, {
				opacity: 1,
			});

			gsap.fromTo(
				$enChar,
				{
					display: 'inline-block',
					yPercent: 101,
				},
				{
					yPercent: 0,
					duration: 1,
					ease: Ease.gleasing,
					stagger: 0.032,
				}
			);

			gsap.fromTo(
				$headlineJa,
				{
					yPercent: 101,
					display: 'inline-block',
				},
				{
					yPercent: 0,
					duration: 1,
					ease: Ease.gleasing,
					delay: 0.4,
				}
			);

			gsap.fromTo(
				$fvfade,
				{
					opacity: 0,
					y: 20,
				},
				{
					opacity: 1,
					y: 0,
					duration: 1,
					ease: Ease.DoubleSineOut,
					delay: 0.8,
				}
			);
		}

		setTimeout(() => {
			fvAnimation();
		}, 400);
	}

	const $$copy = document.querySelectorAll('.js-copy');
	if ($$copy.length > 0) {
		$$copy.forEach(($copy) => {
			const $head = $copy.querySelector('.js-copy-head');

			ScrollTrigger.create({
				trigger: $head,
				onEnter: () => {
					$head.classList.add('is-show');
				},
			});
		});
	}

	const $$headlineVertical = document.querySelectorAll(
		'.js-headline-technology-vertical'
	);
	if ($$headlineVertical.length > 0) {
		$$headlineVertical.forEach(($headlineVertical) => {
			const $en = $headlineVertical.querySelector(
				'.js-headline-technology-vertical-en'
			);
			const $ja = $headlineVertical.querySelector(
				'.js-headline-technology-vertical-ja'
			);

			gsap.set($en, {
				display: 'inline-block',
			});

			if ($ja) {
				gsap.set($ja, {
					display: 'inline-block',
				});
			}

			let mm = gsap.matchMedia();

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							gsap.set($headlineVertical, {
								opacity: 1,
							});

							let x = 0;
							let y = 101;

							mm.add('screen and (min-width: 768px)', () => {
								x = 101;
								y = 0;

								gsap.fromTo(
									$en,
									{
										xPercent: x,
										yPercent: y,
									},
									{
										xPercent: 0,
										yPercent: 0,
										duration: 0.6,
										ease: Ease.gleasing,
										delay: 0.3,
									}
								);

								if ($ja) {
									gsap.fromTo(
										$ja,
										{
											xPercent: x,
											yPercent: y,
										},
										{
											xPercent: 0,
											yPercent: 0,
											duration: 0.6,
											ease: Ease.gleasing,
											delay: 0.54,
										}
									);
								}
							});

							mm.add('screen and (max-width: 767px)', () => {
								// delayの値を変更
								gsap.fromTo(
									$en,
									{
										xPercent: x,
										yPercent: y,
									},
									{
										xPercent: 0,
										yPercent: 0,
										duration: 0.6,
										ease: Ease.gleasing,
										delay: 0, // 768px以下でdelayを0に
									}
								);

								if ($ja) {
									gsap.fromTo(
										$ja,
										{
											xPercent: x,
											yPercent: y,
										},
										{
											xPercent: 0,
											yPercent: 0,
											duration: 0.6,
											ease: Ease.gleasing,
											delay: 0.22, // 768px以下でdelayを0.22に
										}
									);
								}
							});

							observer.unobserve($headlineVertical);
						}
					});
				},
				{
					rootMargin: '0px 0px -20% 0px',
				}
			);

			observer.observe($headlineVertical);
		});
	}

	const $$real = document.querySelectorAll('.js-real');
	if ($$real.length > 0) {
		$$real.forEach(($real) => {
			const $headline = $real.querySelector('.js-real-headline');

			gsap.set($headline, {
				yPercent: 120,
				opacity: 1,
			});

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							gsap.to($headline, {
								yPercent: 0,
								duration: 1,
								ease: Ease.gleasing,
							});

							observer.disconnect();
						}
					});
				},
				{
					rootMargin: '0px 0px -20% 0px',
				}
			);

			observer.observe($real);
		});
	}
});

window.addEventListener('load', () => {});
